import Dashboard from "layouts/dashboard";
import Portfolio from "layouts/portfolio";
import Services from "layouts/services";
import About from "layouts/about";
import Contact from "layouts/contact";
import SolucaoInteligente from "layouts/agente";

// Icons
import { IoHome, IoGrid, IoBuild } from "react-icons/io5";
import { BsFillPersonFill, BsEnvelopeFill } from "react-icons/bs";
// import { BsRobot } from "react-icons/bs";
// import { FiMessageCircle } from "react-icons/fi";
import { MdChat } from "react-icons/md";

const routes = [
  {
    type: "collapse", // ✅ Aparece no menu
    name: "Home",
    key: "home",
    route: "/",
    icon: <IoHome size="15px" color="inherit" />,
    component: Dashboard,
    noCollapse: true,
  },
  {
    type: "route", // ❌ Não aparece no menu
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    component: Dashboard,
  },
  {
    type: "collapse",
    name: "Portfólio",
    key: "portfolio",
    route: "/portfolio",
    icon: <IoGrid size="15px" color="inherit" />,
    component: Portfolio,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Serviços",
    key: "servicos",
    route: "/servicos",
    icon: <IoBuild size="15px" color="inherit" />,
    component: Services,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Sobre Mim",
    key: "sobre",
    route: "/sobre",
    icon: <BsFillPersonFill size="15px" color="inherit" />,
    component: About,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Contato",
    key: "contato",
    route: "/contato",
    icon: <BsEnvelopeFill size="15px" color="inherit" />,
    component: Contact,
    noCollapse: true,
  }, 
  {
    type: "collapse",
    name: "Agente IA",
    key: "agente-ia",
    icon: <MdChat />,
    route: "/solucao-inteligente",
    component: SolucaoInteligente, // ✅ Correto!
  }
  
];

export default routes;